
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.02.447a7.573 7.573 0 107.573 7.573A7.573 7.573 0 008.02.447zm0 14.064a6.491 6.491 0 116.49-6.491 6.491 6.491 0 01-6.49 6.49z"}}),_c('path',{attrs:{"d":"M4.774 7.479h6.491v1.082H4.774z"}})])
          )
        }
      }
    